export default __webpack_public_path__ + "static/media/waves-white.dcb2ce85.svg";